var app = angular.module("leonardo");

var MaintenanceController = function($scope, $state, $rootScope, $element, AuthService, CookieService,
                                     RestangularProvider) {
  if (AuthService.hasToken()) {
    AuthService.logout();
  }

  RestangularProvider.all('health').customGET('', {noerror:true}).then(function () {
    CookieService.removeCookie('leo_maintenance');
    $state.go('home');
  }, function (error){
    if (error.status === 503 && !CookieService.getCookie('leo_maintenance')) {
      CookieService.setCookie('leo_maintenance', true, 1);
    }
    else if (error.status !== 503) {
      CookieService.removeCookie('leo_maintenance');
      $state.go('home');
    }
  });

  $rootScope.loadReact({
    selector: '#maintenance-page',
    $element,
    component: window.reactComponent.Maintenance.MaintenancePage
  });
};

app.controller('MaintenanceController', ['$scope', '$state', '$rootScope', '$element', 'AuthService', 'CookieService',
  'Restangular', MaintenanceController]);
